var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-container',[_c('router-view'),_c('notification'),_c('loader')],1),(this.$route.path !== '/reports/print')?_c('bottom-navigation'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }